import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { Suspense, lazy } from "react";
import {Login} from '../src/components/pages/panel/Login';
import '../src/App.css';
import Tsreject from '../src/components/pages/panel/TimeSheetReject';
import Timesheet from '../src/components/pages/panel/Timesheet';
import Leaves from '../src/components/pages/panel/Leaves';
import Dashboard from '../src/components/pages/panel/Dashboard';
import Tsapproval from './components/pages/panel/TimesheetApproval';
import Tsrapproval from './components/pages/panel/TimesheetRApproval';
import Panellayout from './layout/panel/panellayout';



const Privateroute = lazy(() => import('../src/route/privateroute'));
const Publicroute = lazy(() => import('../src/route/publicroute'));

export const App = () => {
  return (
    <Router>
      <Routes>
        <Route element={<Publicroute />}>
          <Route path="/" element={<Login />} />
        </Route>
        <Route element={<Privateroute />}>
          <Route path="/panel" element={<Panellayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="timesheet" element={<Timesheet />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="*" element={<Dashboard />} />
          </Route>
          <Route path='tsapproval/:token' element={<Tsapproval/>} />
          <Route path='tsrapproval/:token' element={<Tsrapproval/>} />
          <Route path='tsrejected/:token' element={<Tsreject/>} />
        </Route>
      </Routes>
    </Router>
  );
};